'use client';

export const STORAGE_KEYS = {
    RECENTLY_PLAYED_GAMES: 'RECENTLY_PLAYED_GAMES',
    ACCOUNT_UM_SESSION: 'ACCOUNT_UM_SESSION',
    EXCLUSIVE_POPUP_SEEN_ZONES: 'EXCLUSIVE_POPUP_SEEN_ZONES',
    SESSION_CASINO: 'session-casino',
    NAVIGATION_SOURCE: 'navigationSource'
};

export type StoreKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

export type StorageItem = {
    key: StoreKey;
    value: string;
};

export type StorageType = 'local' | 'session';

export const store = (item: StorageItem, storageType: StorageType = 'session'): void => {
    const storage = storageType === 'local' ? window.localStorage : window.sessionStorage;

    storage.setItem(item.key, item.value);
};

export const retrieve = (key: StoreKey, storageType: StorageType = 'session'): string | null => {
    const storage = storageType === 'local' ? window.localStorage : window.sessionStorage;

    return storage.getItem(key);
};

export const remove = (key: StoreKey, storageType: StorageType = 'session'): void => {
    const storage = storageType === 'local' ? window.localStorage : window.sessionStorage;

    storage.removeItem(key);
};

export const getSessionId = (): string | null => {
    try {
        const sessionData = retrieve(STORAGE_KEYS.SESSION_CASINO, 'local');
        if (!sessionData) {
            return null;
        }

        const session = JSON.parse(sessionData);
        return session?.sessionId || null;
    } catch {
        return null;
    }
};
